export const navigationHeader = [
 
    {
        id: "0",
        title: "Solutions",
        // url: "/solutions",
        url: "/",
    },
    {
        id: "1",
        title: "Customers",
        // url: "/customers",
        url: "/",
    },
    {
        id: "2",
        title: "Questions? Call +91 8950594944",
        url: "/",
    },
];

export const navigationFooter = [
    {
        id: "0",
        title: "Features",
        // url: "/features",
        url: "/",
        links: [
            {
                id: "0",
                title: "Payment Link",
                url: "/",
            },
            {
                id: "1",
                title: "Recurring Billing",
                url: "/",
            },
            {
                id: "2",
                title: "Invoicing",
                url: "/",
            },
            {
                id: "3",
                title: "Checkout",
                url: "/",
            },
            {
                id: "4",
                title: "Integrations",
                // url: "/integrations",
                url: "/",
            },
            {
                id: "5",
                title: "Pricing",
                // url: "/pricing",
                url: "/",
            },
        ],
    },
    {
        id: "1",
        title: "Solutions",
        // url: "/solutions",
        url: "/",
        links: [
            {
                id: "0",
                title: "eCommerce",
                url: "/",
            },
            {
                id: "1",
                title: "Finance Automation",
                url: "/",
            },
            {
                id: "2",
                title: "Crypto",
                url: "/",
            },
            {
                id: "3",
                title: "Global Business",
                url: "/",
            },
            {
                id: "4",
                title: "Marketplaces",
                url: "/",
            },
        ],
    },
    {
        id: "2",
        title: "Resources",
        // url: "/integrations",
        url: "/",
        links: [
            {
                id: "0",
                title: "Tutorials",
                // url: "/documentation",
                url: "/",
            },
            {
                id: "1",
                title: "Blog",
                // url: "/blog",
                url: "/",
            },
            {
                id: "2",
                title: "Community",
                url: "/",
            },
            {
                id: "3",
                title: "Privacy Policy",
                url: "/privacy",
                
            },
        ],
    },
    {
        id: "3",
        title: "About",
        // url: "/about-us",
        url: "/",
        links: [
            {
                id: "0",
                title: "Company",
                url: "/",
            },
            {
                id: "1",
                title: "Careers",
                // url: "/career",
                url: "/",
            },
            {
                id: "2",
                title: "FAQ",
                // url: "/faq",
                url: "/",
            },
            {
                id: "3",
                title: "Contact Us",
                // url: "/contact-us",
                url: "/",
            },
        ],
    },
];
